// extracted by mini-css-extract-plugin
export default {"btnContainer":"ModalConfirmation_btnContainer__curBr"};